import { buildClosedConfig, buildClosedOptions } from '../shared/closedConfig'

const FSMConfigTravelNO = buildClosedConfig('QBFlowMachineTravel')
const FSMOptionsTravelNO = buildClosedOptions()

export { FSMConfigTravelNO, FSMOptionsTravelNO }
